"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESigValidationPage = void 0;
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const ESigValidationPage = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    return react_1.default.createElement("div", { className: "flex flex-col gap-y-4 h-full justify-center w-full lg:w-[700px] py-4 lg:py-0 px-4 lg:px-20" }, "Signature verified successfully.");
};
exports.ESigValidationPage = ESigValidationPage;
